import React from 'react'

export default function About() {
    return (
        <div className="content about container">
            <h2>About</h2>
            <p>We are a passionate team of Web Developers looking forward to work with our "Loyal Customers" like you.</p>
        </div>
    )
}
